import { BaseService } from './../base'

export class CellarService extends BaseService {
  static get entity () {
    return 'cellar'
  }
  static get name () {
    return 'cellar'
  }
}